const ordinaryPrincipalRoles = [
  "platform.owner",
  "hub.admin",
  "studio.admin",
  "ontology.console_admin",
] as const;

export function availableRoleOptions(isExactBreakGlassAdmin: boolean): readonly string[] {
  return isExactBreakGlassAdmin ? ["platform.super_admin"] : ordinaryPrincipalRoles;
}

export function isRoleVisible(role: string, isExactBreakGlassAdmin: boolean): boolean {
  if (role === "hub.user" || role === "studio.user") return false;
  return role !== "platform.super_admin" || isExactBreakGlassAdmin;
}

export function visibleRoles(
  roles: readonly string[],
  isExactBreakGlassAdmin: boolean,
): string[] {
  return roles.filter((role) => isRoleVisible(role, isExactBreakGlassAdmin));
}
